/**
 * Derives the effective discount percentage from stored totals.
 *
 * The percentage is `discountNet / standardNet`, as a percent. It is not read
 * from a category rate. A missing or zero standard net returns `0`.
 *
 * @param discountNet The stored discount net.
 * @param standardNet The stored standard net the discount was taken from.
 * @returns The percentage, for example `10` for a tenth off. `null` and `undefined` inputs are `0`.
 * @example
 * ```ts
 * toEffectiveDiscountPercentage(10, 400); // 2.5
 * toEffectiveDiscountPercentage(10, 0); // 0
 * ```
 */
export function toEffectiveDiscountPercentage(
  discountNet: number | null | undefined,
  standardNet: number | null | undefined,
): number {
  const standard = Number(standardNet ?? 0);

  if (standard === 0) {
    return 0;
  }

  return (Number(discountNet ?? 0) / standard) * 100;
}
